import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import { Container, Card, Form, Button, Alert, Spinner } from 'react-bootstrap';
import { verifyOTP, requestOTP, clearPortalError } from '../../redux/reducers/portalAuthSlice';
import { LuArrowLeft } from "react-icons/lu";

const PortalVerifyOTP = () => {
    const location = useLocation();
    const email = location.state?.email;
    const [otp, setOtp] = useState(['', '', '', '', '', '']);
    const inputs = useRef([]);
    
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { loading, error, portalToken, customer, tempBusinesses } = useSelector((state) => state.portalAuth);

    useEffect(() => {
        if (!email) {
            navigate('/customer-side/login');
        }
    }, [email, navigate]);

    useEffect(() => {
        if (tempBusinesses && tempBusinesses.length > 0) {
            navigate('/customer-side/select-business', { state: { email } });
        } else if (portalToken && customer?.businessId) {
            navigate(`/customer-side/${customer.businessId}/dashboard`);
        }
    }, [portalToken, customer, tempBusinesses, navigate, email]);

    const handleChange = (index, value) => {
        if (isNaN(value)) return;
        const newOtp = [...otp];
        newOtp[index] = value.substring(value.length - 1);
        setOtp(newOtp);

        // Move to next input
        if (value && index < 5) {
            inputs.current[index + 1].focus();
        }
    };

    const handleKeyDown = (index, e) => {
        if (e.key === 'Backspace' && !otp[index] && index > 0) {
            inputs.current[index - 1].focus();
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        dispatch(verifyOTP({ email, otp: otp.join('') }));
    };

    const handleResend = () => {
        dispatch(requestOTP(email));
        dispatch(clearPortalError());
    };

    return (
        <div className="bg-light min-vh-100 d-flex align-items-center">
            <Container>
                <div className="text-center mb-4">
                    <h2 className="fw-bold text-dark">Verify Your Account</h2>
                    <p className="text-muted">Enter the 6-digit code sent to <br/><span className="text-dark fw-semibold">{email}</span></p>
                </div>

                <Card className="border-0 shadow-sm rounded-4 mx-auto" style={{ maxWidth: '450px' }}>
                    <Card.Body className="p-4 p-md-5">
                        {error && <Alert variant="danger" className="rounded-3 small text-center">{error}</Alert>}

                        <Form onSubmit={handleSubmit}>
                            <div className="d-flex gap-2 justify-content-center mb-4">
                                {otp.map((digit, index) => (
                                    <Form.Control
                                        key={index}
                                        ref={(el) => (inputs.current[index] = el)}
                                        type="text"
                                        className="text-center fw-bold fs-3 rounded-3 p-0"
                                        style={{ width: '45px', height: '55px', border: '2px solid #e2e8f0' }}
                                        value={digit}
                                        onChange={(e) => handleChange(index, e.target.value)}
                                        onKeyDown={(e) => handleKeyDown(index, e)}
                                        maxLength={1}
                                        disabled={loading}
                                    />
                                ))}
                            </div>

                            <Button
                                type="submit"
                                className="w-100 rounded-3 py-2 fw-bold text-white border-0 mb-3"
                                style={{ background: "#28B0C4" }}
                                disabled={loading || otp.some(d => !d)}
                            >
                                {loading ? <Spinner animation="border" size="sm" /> : 'Verify & Login'}
                            </Button>
                            
                            <Button 
                                variant="link" 
                                className="w-100 text-decoration-none text-muted small py-0"
                                onClick={handleResend}
                                disabled={loading}
                            >
                                Didn't receive code? <span style={{ color: "#28B0C4" }}>Resend</span>
                            </Button>
                        </Form>

                        <hr className="my-4" />

                        <Button 
                            variant="link" 
                            className="w-100 text-decoration-none text-muted small d-flex align-items-center justify-content-center gap-2"
                            onClick={() => navigate('/customer-side/login')}
                        >
                            <LuArrowLeft size={16} /> Back to login
                        </Button>
                    </Card.Body>
                </Card>
            </Container>
        </div>
    );
};

export default PortalVerifyOTP;
